<template>
  <div v-if="visible" class="privacy-modal-overlay" @click="handleOverlayClick">
    <div class="privacy-modal" @click.stop>
      <div class="modal-header">
        <h3>隐私协议</h3>
      </div>
      <div class="modal-content">
        <div class="agreement-text">
          <p>本次会议为公开活动，报名参加本次活动，则视为您已阅读并同意以下约定:</p>
          <p>"您填写的贵公司参会人员信息(姓名、地址、电子邮件地址、电话号码等)都将受到大会网站隐私条款保护。活动支持单位是经过大会主办单位认证的国内外优秀的智能制造供应商。为了促进供需双方的交流与合作，您同意苏信会与活动支持单位共享前述信息，(如:腾讯云计算(北京)有限公司等)在会后联系您和报名的同事。"为您介绍具体服务、产品、活动等相关事宜。</p>
        </div>
      </div>
      <div class="modal-footer">
        <button 
          class="btn-cancel" 
          @click="handleCancel"
        >
          取消
        </button>
        <button 
          class="btn-agree" 
          :class="{ 'disabled': !canAgree }"
          :disabled="!canAgree"
          @click="handleAgree"
        >
          {{ agreeButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyAgreementModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      canAgree: false,
      countdown: 5,
      timer: null
    }
  },
  computed: {
    agreeButtonText() {
      if (this.canAgree) {
        return '同意并继续'
      } else {
        return `同意并继续 (${this.countdown}s)`
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.startCountdown()
      } else {
        this.resetCountdown()
      }
    }
  },
  methods: {
    startCountdown() {
      this.canAgree = false
      this.countdown = 5
      
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.canAgree = true
          this.clearTimer()
        }
      }, 1000)
    },
    resetCountdown() {
      this.canAgree = false
      this.countdown = 5
      this.clearTimer()
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    handleOverlayClick() {
      // 点击遮罩层不关闭模态框，用户必须选择同意或取消
    },
    handleCancel() {
      this.$emit('cancel')
    },
    handleAgree() {
      if (this.canAgree) {
        this.$emit('agree')
      }
    }
  },
  beforeDestroy() {
    this.clearTimer()
  }
}
</script>

<style lang="less" scoped>
.privacy-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.privacy-modal {
  width: 90%;
  max-width: 600px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  padding: 24px 24px 16px;
  border-bottom: 1px solid #e5e5e5;
  
  h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
    text-align: center;
    font-weight: 500;
  }
}

.modal-content {
  padding: 24px;
  max-height: 400px;
  overflow-y: auto;
}

.agreement-text {
  p {
    margin: 0 0 16px 0;
    font-size: 14px;
    line-height: 1.6;
    color: #666;
    text-align: justify;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.modal-footer {
  padding: 16px 24px 24px;
  display: flex;
  gap: 16px;
  border-top: 1px solid #e5e5e5;
}

.btn-cancel,
.btn-agree {
  flex: 1;
  height: 50px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancel {
  background: #f5f5f5;
  color: #666;
  
  &:active {
    background: #e5e5e5;
  }
}

.btn-agree {
  background: #005fd5;
  color: #fff;
  
  &:not(.disabled):active {
    background: #004bb8;
  }
  
  &.disabled {
    background: rgba(0, 95, 213, 0.5);
    color: #fff;
    cursor: not-allowed;
  }
}
</style>
